import React, { useContext, useEffect, useState } from 'react'
import { AutoComplete, Form } from "antd";
import { getStockById, getStocksAsSelect } from "../../../../../services/serviceStock";
import { RecipeConText } from "../../../../../context/RecipeContext";

const { Option } = AutoComplete

const RecipeItemStock = ({ rowId }) => {

    const [stocks, setStocks] = useState([])
    const { rowData } = useContext(RecipeConText)
    const [rowState, setRowState] = rowData

    useEffect(() => {
        getStocksAsSelect()
            .then(({ data }) => {
                const stockData = data.map(item => ({
                    text: `${item.value} - ${item.label}`,
                        value: item.key
                }))
                setStocks(stockData)
            })
    }, [])

    const handleStockChange = (value, option) => {
        if (option.key) {
            getStockById(option.key)
                .then(({ data }) => {
                    let mockRows = Object.assign({}, rowState)
                    mockRows[rowId].data = data
                    setRowState(mockRows)
                })
        }
    }

    return (
        <React.Fragment>
            <Form
                wrapperCol={{ span: 24 }}
            >
                <Form.Item>
                    <AutoComplete
                        className={'recipe-stock-select'}
                        onChange={handleStockChange}
                        filterOption={(inputValue, option) =>
                            option.value.toLocaleLowerCase().indexOf(inputValue.toLocaleLowerCase()) !== -1
                        }
                    >
                        {stocks.map(({ value, text }) => (
                            <Option key={value} value={text} >{text}</Option>
                        ))}
                    </AutoComplete>
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default RecipeItemStock